module.exports = __webpack_public_path__ + "img/Invasion-SCC_GSE144240.510c8641.png";